document.addEventListener("DOMContentLoaded", function(event) {
  var swiper = new Swiper(".announcement-carousel", {
    grabCursor: true,
    slidesPerView: "1",
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
  });
   // Function to adjust slide heights
  function adjustSlideHeights() {
        // Define mobile screen width threshold
        const mobileThreshold = 768;

        // Check if the current screen width is mobile
        if (window.innerWidth <= mobileThreshold) {
            // Select all the elements within the carousel
            const slides = document.querySelectorAll(".announcement-bar");

            // Initialize a variable to keep track of the maximum height
            let maxHeight = 0;

            // Calculate the maximum height of all slides
            slides.forEach(slide => {
                // Reset height to auto to recalculate
                slide.style.height = 'auto';
                const slideHeight = slide.offsetHeight;
                if (slideHeight > maxHeight) {
                    maxHeight = slideHeight;
                }
            });

            // Set each slide's height to the maximum height
            slides.forEach(slide => {
                slide.style.height = `${maxHeight}px`;
            });
        } else {
            // Reset heights if not on mobile
            const slides = document.querySelectorAll(".announcement-bar");
            slides.forEach(slide => {
                slide.style.height = 'auto';
            });
        }
    }

    // Initial adjustment
    adjustSlideHeights();

    // Adjust on window resize
    window.addEventListener("resize", adjustSlideHeights);
});  